/**
 * UserManagement screen styles
 */

import { StyleSheet, Dimensions } from 'react-native'
import { heightPercentageToDP as hp, widthPercentageToDP as wp } from 'react-native-responsive-screen';
import { isWeb } from '../../util/platform';

import { fonts } from '../fonts';
import AppStyles from '../../AppStyles';

const screenWidth = Dimensions.get('window').width;
let scale = 1;
if (screenWidth < 900 && isWeb()) {
  scale = 0.7;
}

const styles = StyleSheet.create({
  safeAreaContainer: {
    flex: 1,
    backgroundColor: AppStyles.colorSet.whiteColor,
  },
  container: {
    flex: 1,
    alignItems: 'center',
    width: '100%',
  },
  error: {
    color: AppStyles.colorSet.error,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  // V3: Card container for form sections
  formCard: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 20,
    marginTop: 10,
    marginHorizontal: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
    elevation: 2,
    borderWidth: 1,
    borderColor: '#F0F0F0',
    width: '90%',
    maxWidth: 500,
    alignSelf: 'center',
  },
  // V3: Card container for search/filter section
  filterCard: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 16,
    marginHorizontal: 16,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.04,
    shadowRadius: 8,
    elevation: 2,
    borderWidth: 1,
    borderColor: '#F0F0F0',
  },
  chip_container: {
    backgroundColor: AppStyles.colorSet.whiteColor,
    flex: 1,
    maxHeight: 40,
    marginTop: 5,
    marginBottom: 25,
  },
  ChipText: {
    marginHorizontal: wp(2),
  },
  // V3: Clean white unselected chip with subtle border
  Chip: {
    marginHorizontal: wp(0),
    backgroundColor: '#ffffff',
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 100,
    borderColor: '#E5E7EB',
    borderWidth: 1,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.03,
    shadowRadius: 2,
    elevation: 1,
  },
  // V3: Gold selected chip with subtle shadow
  ChipSelected: {
    marginHorizontal: wp(0),
    backgroundColor: AppStyles.colorSet.brandPrimary,
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
    borderRadius: 100,
    borderColor: AppStyles.colorSet.brandPrimary,
    borderWidth: 1,
    shadowColor: '#FFC451',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 2,
  },
  // Web hover/focus feedback for the (unselected) mode tabs
  ChipHovered: {
    borderColor: AppStyles.colorSet.brandPrimary,
    backgroundColor: 'rgba(255, 196, 81, 0.08)',
  },
  // Create mode dropdowns - use 100% width to fit within formCard
  dropdownWeb: { marginBottom: 5, width: '100%' },
  dropdownMobile: { marginBottom: 5, width: '100%' },
  orgRowWeb: { flexDirection: 'row', width: '100%' },
  orgRowMobile: { flexDirection: 'row', width: '100%' },
  orgDropdownLeftWeb: { marginRight: 4, marginBottom: 25, width: '49%', height: hp(4) },
  orgDropdownLeftMobile: { marginRight: 4, marginBottom: 5, height: hp(4), width: '49%' },
  orgDropdownRightWeb: { marginBottom: 25, height: hp(4), width: '49%' },
  orgDropdownRightMobile: { marginBottom: 5, height: hp(4), width: '49%' },
  // V3: Search container with card styling
  searchContainer: {
    width: '100%',
    paddingHorizontal: 16,
    display: 'flex',
    justifyContent: 'center',
    zIndex: 10,
  },
  searchContainerWeb: {
    zIndex: 10,
  },
  searchBoxWeb: { marginTop: 15, marginLeft: 5, width: wp(55) },
  searchBoxMobile: { marginTop: 15, marginBottom: 5, width: '100%' },
  // Filter row
  filterRowWeb: { flexDirection: 'row', width: wp(55) },
  filterRowMobile: { flexDirection: 'row', width: '100%', justifyContent: 'space-between' },
  filterDropdownLeftWeb: { marginLeft: 5, marginRight: 2, width: '49%', height: hp(4) },
  filterDropdownLeftMobile: { marginBottom: 5, height: hp(4), width: '49%' },
  filterDropdownRightWeb: { marginLeft: 5, height: hp(4), width: '50%' },
  filterDropdownRightMobile: { marginBottom: 5, height: hp(4), width: '49%' },
  // Small dropdown style
  smallDropdown: { minHeight: 28, maxHeight: 28, marginTop: 5 },
  smallDropdownText: { fontSize: 14 },
  smallDropdownBadge: { height: 20 },
  // Org filter (edit mode)
  orgFilterWeb: { marginLeft: 5, width: wp(55) },
  orgFilterMobile: { marginBottom: 5, width: '100%' },
  // Table scroll
  tableScrollWeb: { height: 300, marginTop: 15, paddingTop: 20, marginBottom: 5, width: wp(55), zIndex: 1 },
  tableScrollMobile: { height: 300, paddingTop: 20, marginTop: 15, marginBottom: 5, width: '100%', zIndex: 1 },
  // V3: Search textbox with white background and subtle border
  textboxContainer: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#E5E7EB',
    width: '100%',
    height: hp(5),
    marginTop: hp(0),
    justifyContent: 'center',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.03,
    shadowRadius: 4,
    elevation: 1,
  },
  textboxResetSearch: {
    flex: 1,
    backgroundColor: 'transparent',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: 50,
  },
  textboxText: {
    flex: 4,
    fontFamily: fonts.POPPINS.regular,
    fontSize: 18 * scale,
    color: '#111827',
    paddingLeft: 12,
    marginLeft: 4,
    width: '100%',
  },
  // Bulk create help link
  bulkCreateHelp: {
    alignSelf: 'center',
    paddingVertical: 8,
  },
  bulkCreateHelpText: {
    color: '#B8860B', // Dark goldenrod - better contrast than brandPrimary
    fontSize: 14,
    textDecorationLine: 'underline',
  },
});

export default styles;
